module.exports = __webpack_public_path__ + "static/media/birthday.66f33279.png";